var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileTypeCad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 30H21.5C22.8807 30 24 28.8807 24 27.5V9.62018C24 8.94933 23.7304 8.30663 23.2518 7.83656L16.0021 0.71638C15.5347 0.257247 14.9056 0 14.2504 0H2.5C1.11929 0 0 1.11929 0 2.5V27.5C0 28.8807 1.11929 30 2.5 30Z",
    fill: "#003393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5969 10.1071C11.8467 9.96432 12.1533 9.96432 12.4031 10.1071L18.0906 13.3571C18.3438 13.5017 18.5 13.7709 18.5 14.0625V20.5625C18.5 20.8541 18.3438 21.1233 18.0906 21.2679L12.4031 24.5179C12.1533 24.6607 11.8467 24.6607 11.5969 24.5179L5.90939 21.2679C5.65623 21.1233 5.5 20.8541 5.5 20.5625V14.0625C5.5 13.7709 5.65623 13.5017 5.90939 13.3571L11.5969 10.1071ZM7.125 15.4626V20.091L11.1875 22.4124V17.784L7.125 15.4626ZM12.8125 17.784V22.4124L16.875 20.091V15.4626L12.8125 17.784ZM16.0499 14.0625L12 16.3767L7.95015 14.0625L12 11.7483L16.0499 14.0625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypeCad);
export default __webpack_public_path__ + "static/media/file-type-cad.8ec6407ae20ab87f1d4770d68dc3f559.svg";
export { ForwardRef as ReactComponent };